export default (values) => {
    const errors = {}

    let newPassword = values['new-password']
    let currentPassword = values['password']
    let confirmPassword = values['confirm-password']

    if (newPassword || currentPassword || confirmPassword) {
        if (!newPassword) errors['new-password'] = 'New password is required when current or confirm passwords are filled'
        if (!currentPassword) errors['password'] = 'Current password is required when new or confirm passwords are filled'
        if (!confirmPassword) errors['confirm-password'] = 'Confirm password is required when new or current passwords are filled'
        if (newPassword !== confirmPassword) errors['confirm-password'] = 'Confirm should match the new password'
    }

    // if (!values.username) {
    //     errors.username = 'Required'
    // } else if (values.username.length > 15) {
    //     errors.username = 'Must be 15 characters or less'
    // }
    // if (!values.email) {
    //     errors.email = 'Required'
    // } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
    //     errors.email = 'Invalid email address'
    // }
    // if (!values.age) {
    //     errors.age = 'Required'
    // } else if (isNaN(Number(values.age))) {
    //     errors.age = 'Must be a number'
    // } else if (Number(values.age) < 18) {
    //     errors.age = 'Sorry, you must be at least 18 years old'
    // }
    return errors
}


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/Profile/validate.js